import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function MultipleCorrelation({ response }) {
  const key1 = response?.headers?.join() || "";

  return (
    <TableContainer component={Paper} sx={{ ml: 3, mt: 2 }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead key={key1}>
          <TableRow key={`${key1}2`}>
            {/* <TableCell></TableCell> */}
            {response?.headers?.map((header, index) => {
              return <TableCell key={index}>{header}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody key={`${key1}3`}>
          {/* {console.log(response?.rows, "ROW")} */}
          {response?.rows?.map((row, i) => (
            <TableRow key={i}>
              {/* {console.log(row, "TEST")} */}
              {row?.[response?.headers[i]].map((cell, index) => (
                <TableCell key={`${i}-${index}`} component="th" scope="row">
                  {/* {console.log({ cell })} */}
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default MultipleCorrelation;


